import { createActions, createReducer } from 'reduxsauce'

import OrgaoService from '$/servicos/OrgaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaInfoOrgaoInicio: [],
    buscaInfoOrgaoSucesso: ['info'],
    buscaInfoOrgaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    info: {},
}

// Ação para busca completa
Creators.buscaInfoOrgao = () => {
    return dispatch => {
        dispatch(Creators.buscaInfoOrgaoInicio())
        let serv = new OrgaoService()
        return serv
            .getInfo()
            .then(response => dispatch(Creators.buscaInfoOrgaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaInfoOrgaoErro(error)))
    }
}

const buscaInfoOrgaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaInfoOrgaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaInfoOrgaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, info: action.info, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_INFO_ORGAO_INICIO]: buscaInfoOrgaoInicio,
    [Types.BUSCA_INFO_ORGAO_ERRO]: buscaInfoOrgaoErro,
    [Types.BUSCA_INFO_ORGAO_SUCESSO]: buscaInfoOrgaoSucesso,
})
